WeightedTable = function () {
  this._outcomes = [];
  this._totalWeight = 0;

  this.addOutcome = function (outcomeToAdd, chanceToAdd) {
    this._outcomes.push({
      outcome: outcomeToAdd,
      chance: chanceToAdd,
    });
    this._totalWeight += chanceToAdd;
  };

  this.clearOutcomes = function () {
    this._outcomes = [];
    this._totalWeight = 0;
  }

  this.getOutcomes = function () {
    return this._outcomes;
  }

  this.getOutcomeSize = function () {
    return this._outcomes.length;
  }

  this.pickOutcome = function () {
    let runningTotal = 0;
    let selectedOutcome = Math.floor(Math.random() * this._totalWeight);

    for (let i = 0; i < this._outcomes.length; ++i) {
      runningTotal += this._outcomes[i].chance;
      if (runningTotal > selectedOutcome) {
        return this._outcomes[i].outcome;
      }
    }
  };
};
